'use client';

import * as React from 'react';
export const SuggestionsContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") SuggestionsContext.displayName = "SuggestionsContext";
export function useSuggestionsContext() {
  return React.useContext(SuggestionsContext);
}